import React, {useState,useEffect} from 'react'
import {Container} from "reactstrap"
import {Table,Button} from "react-bootstrap"
import { useHistory } from "react-router-dom"
import "./growth.css"
import Header from "./Header"
import Footer from "./Footer"
import { Icon, InlineIcon } from '@iconify/react';
import graphIcon from '@iconify-icons/codicon/graph';


function PlotGraph() {

    //1
    const [dol, setDol] = useState(""); 
    const [postweek, setPostWeek] = useState("");
    const [postday, setPostDay] = useState(""); 
    const [weight, setWeight] = useState("");
    const [length, setLength] = useState("");
    const [hc, setHC] = useState("");

    //2
    const [dol2, setDol2] = useState(""); 
    const [postweek2, setPostWeek2] = useState("");
    const [postday2, setPostDay2] = useState(""); 
    const [weight2, setWeight2] = useState("");
    const [length2, setLength2] = useState("");
    const [hc2, setHC2] = useState("");

    //3
    const [dol3, setDol3] = useState(""); 
    const [postweek3, setPostWeek3] = useState("");
    const [postday3, setPostDay3] = useState(""); 
    const [weight3, setWeight3] = useState("");
    const [length3, setLength3] = useState("");
    const [hc3, setHC3] = useState("");

    //4
    const [dol4, setDol4] = useState(""); 
    const [postweek4, setPostWeek4] = useState("");
    const [postday4, setPostDay4] = useState(""); 
    const [weight4, setWeight4] = useState("");
    const [length4, setLength4] = useState("");
    const [hc4, setHC4] = useState("");

    //5
    const [dol5, setDol5] = useState(""); 
    const [postweek5, setPostWeek5] = useState("");
    const [postday5, setPostDay5] = useState(""); 
    const [weight5, setWeight5] = useState("");
    const [length5, setLength5] = useState("");
    const [hc5, setHC5] = useState("");

    //6
    const [dol6, setDol6] = useState(""); 
    const [postweek6, setPostWeek6] = useState("");
    const [postday6, setPostDay6] = useState(""); 
    const [weight6, setWeight6] = useState("");
    const [length6, setLength6] = useState("");
    const [hc6, setHC6] = useState("");

    //7
    const [dol7, setDol7] = useState(""); 
    const [postweek7, setPostWeek7] = useState("");
    const [postday7, setPostDay7] = useState(""); 
    const [weight7, setWeight7] = useState("");
    const [length7, setLength7] = useState("");
    const [hc7, setHC7] = useState("");

    //8
    const [dol8, setDol8] = useState(""); 
    const [postweek8, setPostWeek8] = useState("");
    const [postday8, setPostDay8] = useState(""); 
    const [weight8, setWeight8] = useState("");
    const [length8, setLength8] = useState("");
    const [hc8, setHC8] = useState("");



    const [disabledTick, setDisabledTick] = useState(false)
    const [disabledText, setDisabledText] = useState(false)

    let history = useHistory();

     const handleDol = (event) => {
        setDol(event.target.value);
        localStorage.setItem("Day of life 1", event.target.value);
      };

      const handleDol2 = (event) => {
        setDol2(event.target.value);
        localStorage.setItem("Day of life 2", event.target.value);
      };

      const handleDol3 = (event) => {
        setDol3(event.target.value);
        localStorage.setItem("Day of life 3", event.target.value);
      };

      const handleDol4 = (event) => {
        setDol4(event.target.value);
        localStorage.setItem("Day of life 4", event.target.value);
      };

      const handleDol5 = (event) => {
        if(!disabledTick){
          setDol5(event.target.value);
          localStorage.setItem("Day of life 5", event.target.value);
        }
      };
  
      const handleDol6 = (event) => {
        if(!disabledTick){
          setDol6(event.target.value);
          localStorage.setItem("Day of life 6", event.target.value);
        }
      };
  
      const handleDol7 = (event) => {
        if(!disabledTick){
          setDol7(event.target.value);
          localStorage.setItem("Day of life 7", event.target.value);
        }
      };
  
      const handleDol8 = (event) => {
        if(!disabledTick){
          setDol8(event.target.value);
          localStorage.setItem("Day of life 8", event.target.value);
        }
      };

   

      const handlePostWeek = (event) => {
        setPostWeek(event.target.value);
        localStorage.setItem("Post week 1", event.target.value);
      };

      const handlePostWeek2 = (event) => {
        setPostWeek2(event.target.value);
        localStorage.setItem("Post week 2", event.target.value);
      };

      const handlePostWeek3 = (event) => {
        setPostWeek3(event.target.value);
        localStorage.setItem("Post week 3", event.target.value);
      };

      const handlePostWeek4 = (event) => {
        setPostWeek4(event.target.value);
        localStorage.setItem("Post week 4", event.target.value);
      };

      const handlePostWeek5 = (event) => {
        if(!disabledTick){
        setPostWeek5(event.target.value);
        localStorage.setItem("Post week 5", event.target.value);
        }
      };

      const handlePostWeek6 = (event) => {
        if(!disabledTick){
        setPostWeek6(event.target.value);
        localStorage.setItem("Post week 6", event.target.value);
        }
      };

      const handlePostWeek7 = (event) => {
        if(!disabledTick){
        setPostWeek7(event.target.value);
        localStorage.setItem("Post week 7", event.target.value);
        }
      };

      const handlePostWeek8 = (event) => {
        if(!disabledTick){
        setPostWeek8(event.target.value);
        localStorage.setItem("Post week 8", event.target.value);
        }
      };


      const handlePostDay= (event) => {
        setPostDay(event.target.value);
        localStorage.setItem("Post day 1", event.target.value);
      };

      const handlePostDay2 = (event) => {
        setPostDay2(event.target.value);
        localStorage.setItem("Post day 2", event.target.value);
      };

      const handlePostDay3 = (event) => {
        setPostDay3(event.target.value);
        localStorage.setItem("Post day 3", event.target.value);
      };

      const handlePostDay4 = (event) => {
        setPostDay4(event.target.value);
        localStorage.setItem("Post day 4", event.target.value);
      };

      const handlePostDay5 = (event) => {
        if(!disabledTick){
        setPostDay5(event.target.value);
        localStorage.setItem("Post day 5", event.target.value);
        }
      };

      const handlePostDay6 = (event) => {
        if(!disabledTick){
        setPostDay6(event.target.value);
        localStorage.setItem("Post day 6", event.target.value);
        }
      };

      const handlePostDay7 = (event) => {
        if(!disabledTick){
        setPostDay7(event.target.value);
        localStorage.setItem("Post day 7", event.target.value);
        }
      };

      const handlePostDay8 = (event) => {
        if(!disabledTick){
        setPostDay8(event.target.value);
        localStorage.setItem("Post day 8", event.target.value);
        }
      };


      const handleWeight = (event) => {
        setWeight(event.target.value);
        localStorage.setItem("weight 1", event.target.value);
      };

      const handleWeight2 = (event) => {
        setWeight2(event.target.value);
        localStorage.setItem("weight 2", event.target.value);

      };
      const handleWeight3 = (event) => {
        setWeight3(event.target.value);
        localStorage.setItem("weight 3", event.target.value);
      };

      const handleWeight4 = (event) => {
        setWeight4(event.target.value);
        localStorage.setItem("weight 4", event.target.value);
      };

      const handleWeight5 = (event) => {
        if(!disabledTick){
        setWeight5(event.target.value);
        localStorage.setItem("weight 5", event.target.value);
        }
      };


      const handleWeight6 = (event) => {
        if(!disabledTick){
        setWeight6(event.target.value);
        localStorage.setItem("weight 6", event.target.value);
        }
      };

      const handleWeight7 = (event) => {
        if(!disabledTick){
        setWeight7(event.target.value);
        localStorage.setItem("weight 7", event.target.value);
        }
      };

      const handleWeight8 = (event) => {
        if(!disabledTick){
        setWeight8(event.target.value);
        localStorage.setItem("weight 8", event.target.value);
        }
      };

      const handleLength = (event) => {
        setLength(event.target.value);
        localStorage.setItem("length 1", event.target.value);
      };

      const handleLength2 = (event) => {
        setLength2(event.target.value);
        localStorage.setItem("length 2", event.target.value);
      };

      const handleLength3 = (event) => {
        setLength3(event.target.value);
        localStorage.setItem("length 3", event.target.value);
      };

      const handleLength4 = (event) => {
        setLength4(event.target.value);
        localStorage.setItem("length 4", event.target.value);
      };

      const handleLength5 = (event) => {
        if(!disabledTick){
        setLength5(event.target.value);
        localStorage.setItem("length 5", event.target.value);
        }
      };

      const handleLength6 = (event) => {
        if(!disabledTick){
        setLength6(event.target.value);
        localStorage.setItem("length 6", event.target.value);
        }
      };

      const handleLength7 = (event) => {
        if(!disabledTick){
        setLength7(event.target.value);
        localStorage.setItem("length 7", event.target.value);
        }
      };

      const handleLength8 = (event) => {
        if(!disabledTick){
        setLength8(event.target.value);
        localStorage.setItem("length 8", event.target.value);
        }
      };


      //Head Circumference Row

      const handleHC = (event) => {
        setHC(event.target.value);
        localStorage.setItem("hc 1", event.target.value);
      };

      const handleHC2 = (event) => {
        setHC2(event.target.value);
        localStorage.setItem("hc 2", event.target.value);
      };

      const handleHC3 = (event) => {
        setHC3(event.target.value);
        localStorage.setItem("hc 3", event.target.value);
      };

      const handleHC4 = (event) => {
        setHC4(event.target.value);
        localStorage.setItem("hc 4", event.target.value);
      };

      const handleHC5 = (event) => {
        if(!disabledTick){
        setHC5(event.target.value);
        localStorage.setItem("hc 5", event.target.value);
        }
      };

      const handleHC6 = (event) => {
        if(!disabledTick){
        setHC6(event.target.value);
        localStorage.setItem("hc 6", event.target.value);
        }
      };

      const handleHC7 = (event) => {
        if(!disabledTick){
        setHC7(event.target.value);
        localStorage.setItem("hc 7", event.target.value);
        }
      };

      const handleHC8 = (event) => {
        if(!disabledTick){
        setHC8(event.target.value);
        localStorage.setItem("hc 8", event.target.value);
        }
      };

    const plot = () => {

        const x = window.scrollTo(0,0) //not working
        history.push("/plot", x);  
        

    }



    const handleDisabledTick = (event) => {


      //need to fill this up warning
      if (dol == "" || dol2 == "" || postweek == "" || postweek2 == "" || postday == "" || postday2 == "" || weight == "" || weight2 == "" || length == "" || length2 == "" || hc == "" || hc2 == "" ){
        alert("Not sufficient data, fill in the required fields")
        setDisabledTick(false)
        setDisabledText(true)
     
      }

      //required fields to fill 
      if (dol != "" && dol2 != "" && postweek != "" && postweek2 != "" && postday != "" && postday2 != "" && weight != "" && weight2 != "" && length != "" && length2 != "" && hc != "" && hc2 != "" ) {

        if(!disabledTick){  //disable input
        setDisabledTick(true)
        setDisabledText(true)
          
        alert("Sufficient data, marking empty fields as NA")
       //IF 2 ROWS fillled, uncheck causes mark empty fields as NA
        }
        
      }


      if(disabledTick){
        setDisabledTick(false)
        setDisabledText(false)
        
      }
      
    }


    return (
        <div className="row">
        <div className="col-md-12">
        <div className = "growth__page1">
        <Header/>
        <div className = "growth__content">
          
        <form onSubmit = {plot}>
          <div className = "growth__header2">
            <div className = "growth__header3">
            <label>Please insert information into the cells. 
            <span><strong>Minimum</strong> 2 time points, <strong>Maximum</strong> 8 time points. 
            <span>Once you're <strong>done</strong>, check the box below.</span></span></label>
            </div>
            </div>
            <Table   striped bordered hover size="sm" responsive="sm"  className="table__plotgraph"> 
                <thead>
                    <tr>
                <th>
                    Time point
                </th>
                <th>
                    Day of Life
                </th>
                <th>
                    PMA (weeks)
                </th>
                <th>
                    PMA (days) 
                </th>
                <th>
                    Weight (kg)
                </th>
                <th>
                    Length (cm)
                </th>
                <th>
                    OFC (cm)
                </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td><p>1</p></td>
                    <td>
                        <input type = "number"  pattern = "^(\d*\.)?\d+$"
                        className = "table__input"
                         required 
                         step="any" placeholder = {disabledTick ? "" : "0"}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handleDol}
                         value = {dol}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                    required 
                         step="any" placeholder = {disabledTick ? "" : "0"}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handlePostWeek}
                         value = {postweek}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                    required 
                         step="any" placeholder = {disabledTick ? "" : "0"}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handlePostDay}
                         value = {postday}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                    required 
                         step="any" placeholder = {disabledTick ? "" : "0.000"}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handleWeight}
                         value = {weight}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                    required 
                         step="any" placeholder = {disabledTick ? "" : "0.0"}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handleLength}
                         value = {length}
                         
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                    required 
                         step="any" placeholder = {disabledTick ? "" : "0.0"}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handleHC}
                         value = {hc}
                        />
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>2</p>
                    </td>
                    <td>
                        <input type = "number"  pattern = "^(\d*\.)?\d+$"
                        className = "table__input"
                        required
                         step="any" placeholder = {disabledTick ? "" : ""}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handleDol2}
                         value = {dol2}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                    required
                         step="any" placeholder = {disabledTick ? "" : ""}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handlePostWeek2}
                         value = {postweek2}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                    required
                         step="any" placeholder = {disabledTick ? "" : ""}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handlePostDay2}
                         value = {postday2}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                    required
                         step="any" placeholder = {disabledTick ? "" : ""}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handleWeight2}
                         value = {weight2}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                    required
                         step="any" placeholder = {disabledTick ? "" : ""}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handleLength2}
                         value = {length2}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                    required
                         step="any" placeholder = {disabledTick ? "" : ""}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handleHC2}
                         value = {hc2}
                        />
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>3</p>
                    </td>
                    <td>
                        <input type = "number"  pattern = "^(\d*\.)?\d+$"
                        className = "table__input"
                         step="any" placeholder = {disabledTick ? "NA" : ""}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handleDol3}
                         value = {dol3}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ? "NA" : ""}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handlePostWeek3}
                         value = {postweek3}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ? "NA" : ""}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handlePostDay3}
                         value = {postday3}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ? "NA" : ""}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handleWeight3}
                         value = {weight3}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ? "NA" : ""}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handleLength3}
                         value = {length3}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ? "NA" : ""}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handleHC3}
                         value = {hc3}
                        />
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>4</p>
                    </td>
                    <td>
                        <input type = "number"  pattern = "^(\d*\.)?\d+$"
                        className = "table__input"
                         step="any" placeholder = {disabledTick ? "NA" : ""}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handleDol4}
                         value = {dol4}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ? "NA" : ""}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handlePostWeek4}
                         value = {postweek4}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ? "NA" : ""}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handlePostDay4}
                         value = {postday4}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ? "NA" : ""}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handleWeight4}
                         value = {weight4}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ? "NA" : ""}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handleLength4}
                         value = {length4}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ? "NA" : ""}
                         disabled = {disabledTick}
                         size="4"
                         onChange = {handleHC4}
                         value = {hc4}
                        />
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>5</p>
                    </td>
                    <td>
                        <input type = "number"  pattern = "^(\d*\.)?\d+$"
                        className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         value = {dol5}
                         disabled = {disabledTick}
                         onChange = {handleDol5}
                         size="4"
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {postweek5}
                         disabled = {disabledTick}
                          
                         onChange = {handlePostWeek5}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {postday5}
                         disabled = {disabledTick}
                          
                         onChange = {handlePostDay5}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {weight5}
                         disabled = {disabledTick}
                          
                         onChange = {handleWeight5}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {length5}
                         disabled = {disabledTick}
                          
                         onChange = {handleLength5}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {hc5}
                         disabled = {disabledTick}
                          
                         onChange = {handleHC5}
                        />
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>6</p>
                    </td>
                    <td>
                        <input type = "number"  pattern = "^(\d*\.)?\d+$"
                        className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {dol6}
                         disabled = {disabledTick}
                          
                         onChange = {handleDol6}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {postweek6}
                         disabled = {disabledTick}
                          
                         onChange = {handlePostWeek6}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {postday6}
                         disabled = {disabledTick}
                          
                         onChange = {handlePostDay6}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {weight6}
                         disabled = {disabledTick}
                          
                         onChange = {handleWeight6}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {length6}
                         disabled = {disabledTick}
                          
                         onChange = {handleLength6}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {hc6}
                         disabled = {disabledTick}
                          
                         onChange = {handleHC6}
                        />
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>7</p>
                    </td>
                    <td>
                        <input 
                        type = "number"  pattern = "^(\d*\.)?\d+$"
                        className = "table__input"
                        step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {dol7}
                         disabled = {disabledTick}
                          
                         onChange = {handleDol7}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {postweek7}
                         disabled = {disabledTick}
                          
                         onChange = {handlePostWeek7}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {postday7}
                         disabled = {disabledTick}
                          
                         onChange = {handlePostDay7}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {weight7}
                         disabled = {disabledTick}
                          
                         onChange = {handleWeight7}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {length7}
                         disabled = {disabledTick}
                          
                         onChange = {handleLength7}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {hc7}
                         disabled = {disabledTick}
                          
                         onChange = {handleHC7}
                        />
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>8</p>
                    </td>
                    <td>
                        <input type = "number"  pattern = "^(\d*\.)?\d+$"
                        className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {dol8}
                         disabled = {disabledTick}
                          
                         onChange = {handleDol8}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {postweek8}
                         disabled = {disabledTick}
                          
                         onChange = {handlePostWeek8}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {postday8}
                         disabled = {disabledTick}
                          
                         onChange = {handlePostDay8}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {weight8}
                         disabled = {disabledTick}
                          
                         onChange = {handleWeight8}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {length8}
                         disabled = {disabledTick}
                          
                         onChange = {handleLength8}
                        />
                    </td>
                    <td>
                    <input type = "number"  pattern = "^(\d*\.)?\d+$"
                    className = "table__input"
                         step="any" placeholder = {disabledTick ?  "NA" : ""} 
                         size="4"
                         value = {hc8}
                         disabled = {disabledTick}
                         
                         onChange = {handleHC8}
                        />
                    </td>
                </tr>
                </tbody>
            </Table>

            <div className = "addtime__button">
            <input required  onChange = {handleDisabledTick} type = "checkbox" checked = {disabledTick}
            className = "table__input" className = "checkbox__done"/>  Yes, I'm done! 
            </div>

            <div className = "plot__graph"> 
                <button className = "goto__plotgraph" onSubmit = {plot} >
                <Icon icon={graphIcon} />   Plot Graph
                </button>
            </div>
            </form>
            </div>
            </div>
        </div>
        </div>
    )
}

export default PlotGraph
